<template>
  <el-dialog
    :title="$t('CHANGE_PASS_changePassword')"
    class="change-password-dialog"
    :data-testid="TEST_ID.CHANGE_PASSWORD_MODAL.ROOT"
    :model-value="show"
    @update:model-value="handleDialogModelUpdate"
    @close="handleOnClose"
    :close-on-click-modal="false"
    width="400px"
  >
   
    <el-form :model="form" :data-testid="TEST_ID.CHANGE_PASSWORD_MODAL.FORM">
      
      <el-form-item :label="$t('CHANGE_PASS_currentPassword')" :error="errors['contraseniaActual']">
        <el-input :data-testid="TEST_ID.CHANGE_PASSWORD_MODAL.INPUT_CURRENT_PASSWORD" v-model="form.contraseniaActual" show-password></el-input>
      </el-form-item>

      <el-form-item :label="$t('CHANGE_PASS_newPassword')" :error="errors['contraseniaNueva']">
        <el-input :data-testid="TEST_ID.CHANGE_PASSWORD_MODAL.INPUT_NEW_PASSWORD" v-model="form.contraseniaNueva" show-password></el-input>
      </el-form-item>

      <el-form-item :label="$t('CHANGE_PASS_repeatNewPassword')" :error="errors['repetirContrasenia']">
        <el-input :data-testid="TEST_ID.CHANGE_PASSWORD_MODAL.INPUT_REPEAT_NEW_PASSWORD" v-model="form.repetirContrasenia" show-password @keyup.enter="onGuardar"></el-input>
      </el-form-item>
    </el-form>

    <template #footer>
      <span class="dialog-footer">
        <el-button :data-testid="TEST_ID.CHANGE_PASSWORD_MODAL.BUTTON_SAVE" type="primary" @click="onGuardar" :loading="cambiandoContrasenia">{{ $t('GENERAL_saveBtn') }}</el-button>
        <el-button :data-testid="TEST_ID.CHANGE_PASSWORD_MODAL.BUTTON_CANCEL" @click="handleOnClose">{{ $t('GENERAL_cancelBtn') }}</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
  import { showError, showSuccess } from '../Mensaje'
  import TEST_ID from '@/testIds.json'
  
  export default {
    name: 'CambioContrasenia',
    props: {
      show: {
        type: Boolean,
        default: false
      },
      onClose: {
        type: Function,
        default: null
      }
    },
    data() {
      return {
        TEST_ID,
        form: {
          contraseniaActual: '',
          contraseniaNueva: '',
          repetirContrasenia: ''
        },
        errors: { },
        cambiandoContrasenia: false
      }
    },
    methods: {
      handleDialogModelUpdate(isOpen) {
        if (!isOpen) {
          this.handleOnClose()
        }
      },
      onGuardar() {
        
        // valido el formulario
        let valida = true
        this.errors = {}

        if(!this.form.contraseniaActual) {
          valida = false
          this.errors['contraseniaActual'] = this.$t('GENERAL_requiredField')
        }

        if(!this.form.contraseniaNueva) {
          valida = false
          this.errors['contraseniaNueva'] = this.$t('GENERAL_requiredField')
        }

        if(!this.form.repetirContrasenia) {
          valida = false
          this.errors['repetirContrasenia'] = this.$t('GENERAL_requiredField')
        }
        else if(this.form.contraseniaNueva && (this.form.repetirContrasenia !== this.form.contraseniaNueva)) {
          valida = false
          this.errors['repetirContrasenia'] = this.$t('CHANGE_PASS_passwordNotEquals')
        }

        // si hubo un error, retorno
        if(!valida)
          return

        // llamo a la lógica de cambio de contraseña
        this.cambiandoContrasenia = true
        let payload = { contraseniaActual: this.form.contraseniaActual, contraseniaNueva: this.form.contraseniaNueva }
        this.$store.dispatch('sesion/cambiarContrasenia', payload)
        .then((data) => {

          // indico que se terminó de cambiar la contraseña
          this.cambiandoContrasenia = false
          
          if(data === undefined)
            return

          // éxito
          if(data === 0)
          {
            // muestro mensaje y cierro la modal
            showSuccess(this.$t('CHANGE_PASS_changePasswordSuccess'))
            this.onClose()
          }

          // muestra mensajes de error
          else if(data === 2) 
            showError(this.$t('CHANGE_PASS_invalidPassword'))
          
          else if(data === 8)
            showError(this.$t('CHANGE_PASS_errorOnChangePassword'))

          else if(data === 9)
            showError(this.$t('CHANGE_PASS_emptyPassword'))

          else if(data === 12)
          showError(this.$t('ERROR_CODE_AUTH_12'))
        })
      },
      handleOnClose() {

        // limpio el formulario
        this.form.contraseniaActual = ''
        this.form.contraseniaNueva = ''
        this.form.repetirContrasenia = ''
        this.errors = { }

        // cierro el modal
        if (this.onClose) {
          this.onClose()
        }
      }
    }
  }

</script>

<style scoped>
  .el-form-item {
    margin-bottom: 15px;
  }

  .usuarioContainer {
    text-align: left;
  }

  .usuarioContainer span {
    margin-right: 10px;
  }

</style>

<style>
  .change-password-dialog .el-dialog__body {
    padding: 24px 20px 10px;
  }
</style>